var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;









pug_html = pug_html + "\u003Cdiv class=\"input input-country input--phone\" :class=\"{&quot;input--error&quot; : showError}\" body-scroll-lock-ignore\u003E\u003Cdiv class=\"input__field input-country__field\"\u003E\u003C!--.input-country__current-code ${ currentCode }}--\u003E\u003Cinput type=\"tel\" name=\"phone\" autocomplete=\"off\"\u003E\u003C\u002Fdiv\u003E\u003Canimation-height :duration-enter=\"0.4\" :duration-leave=\"0.4\"\u003E\u003Cdiv class=\"input__error\" v-if=\"showError\"\u003E\u003Cdiv class=\"input__error-text\"\u003E${ errorText }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fanimation-height\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./core/input/country/input-country.pug
// module id = ./core/input/country/input-country.pug
// module chunks = 0 1 2